import request from '@/utils/request'
import { getToken } from '../utils/auth'

// 登录账号数据
export function queryuser () {
  return request({
    url: '/queryuser',
    method: 'post',
    params: { token: getToken() }
  })
}
// 获取账号（通过组织ID)
export function queryuserbyorgid (data) {
  return request({
    url: '/queryuserbyorgid',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 获取人员账号（通过人员ID）
export function queryuserbyspid (data) {
  return request({
    url: '/queryuserbyspid',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 新建登录账号
export function adduser (data) {
  return request({
    url: '/adduser',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 更新登录账号
export function updateuser (data) {
  return request({
    url: '/updateuser',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 删除登录账号
export function deleteuser (data) {
  return request({
    url: '/deleteuser',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 更改登录账号密码
export function changepwd (data) {
  return request({
    url: '/changepwd',
    method: 'post',
    params: { token: getToken() },
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/account.js